import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const knowledgeBaseMetadataServices = {
  addNewKnowledgeBaseMetadata,
  updateKnowledgeBaseMetadata,
  softDeleteRestoreKnowledgeBaseMetadata,
  deleteKnowledgeBaseMetadata,
  getKnowledgeBaseMetadataData,
};

async function addNewKnowledgeBaseMetadata(payload) {
  const response = await fetch(
    `${config.API_URL}addNewKnowledgeBaseMetadata`,
    headersWithAuth("POST", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateKnowledgeBaseMetadata(payload) {
  const response = await fetch(
    `${config.API_URL}updateKnowledgeBaseMetadata`,
    headersWithAuth("PUT", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreKnowledgeBaseMetadata(payload) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreKnowledgeBaseMetadata`,
    headersWithAuth("PUT", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteKnowledgeBaseMetadata(payload) {
  const response = await fetch(
    `${config.API_URL}deleteKnowledgeBaseMetadata`,
    headersWithAuth("DELETE", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getKnowledgeBaseMetadataData(status, metadataType, searchData = "", page, length) {
  const query = new URLSearchParams();
  query.append("metadataType", metadataType);
  if (searchData) query.append("search", searchData);
  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  const response = await fetch(
    `${config.API_URL}getKnowledgeBaseMetadataData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
